import React from "react";
import CountUp from "react-countup";

function NumberCont({ title, subTitle, sign, purpleText }) {
  return (
    <div className="mb-12">
      <h3
        className={`text-center font-bold text-4xl md:text-4xl lg:text-6xl font-montserrat ${
          purpleText && `text-mix-400`
        }`}
      >
        <span>
          <CountUp end={title} duration={4} />
          {sign}
        </span>
      </h3>

      <p className="text-center font-josefin text-2xl text-gray-600 font-normal pt-4">
        {subTitle}
      </p>
    </div>
  );
}

export default NumberCont;
